module.exports = __webpack_public_path__ + "img/mini_navbar_logo.ef5e3aa8.png";